module.exports = "Une erreur est survenue,\n\nréessayez plus tard."


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/campaigns/i18n/markdown/fr/errorWhileFetchingCampaigns.md
// module id = ./src/statsradio/modules/campaigns/i18n/markdown/fr/errorWhileFetchingCampaigns.md
// module chunks = 18